import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import Hero from "../../Components/LandingComponents/Hero";
import Marquee from "../../Components/LandingComponents/Marquee";
import FeaturesShowcase from "../../Components/LandingComponents/FeaturesShowcase";
import HowTo from "../../Components/LandingComponents/HowTo";
import TestimonialsShowcase from "../../Components/LandingComponents/TestimonialsShowcase";
import FAQSection from "../../Components/LandingComponents/FAQSection";
import CTASection from "../../Components/LandingComponents/CTASection";
import usePageMetadata from "../../Utils/usePageMetadata";

// The global Footer (Components/Footer) still renders below every route including this one.
// The global Header's desktop bar is suppressed for "/" in Header.tsx's `condition()` -- Nav
// below replaces it so there's exactly one desktop nav, not two. Header's mobile menu
// (HeaderMobileView) keeps rendering unconditionally on small screens, same as /home.
const Landing: React.FC = () => {
  usePageMetadata(
    "eZy WaterMark | Own Your Pictures | Add WaterMarks to Your Photos",
    "Add watermarks to your photos. You can add watermarks to a batch of images all at once & or add watermarks to your single image, no registration required, try for free now!"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-redesign">
      <Nav />
      <Hero />
      <Marquee />
      <FeaturesShowcase />
      <HowTo />
      <TestimonialsShowcase />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default Landing;
